import pocketLintView from './pocketLintView.html';
import './pocketLint.css';

export default function pocketLintComponent() {
	return {
		restrict: 'E',
		scope: {},
		bindToController: {
			message: '@',
			class: '@',
		},
		controllerAs: 'vm',
		controller: pocketLintComponentCtrl,
		template: pocketLintView,
	};
}

class pocketLintComponentCtrl {
	constructor() {
		'ngInject';
	}
}
